import { redirectAnonymousUsers } from 'containers/auth-redirect-hocs'
import GeneralProfilePage from 'containers/general-profile'

const GeneralProfilePageProtected = redirectAnonymousUsers(GeneralProfilePage, '/login')
export default GeneralProfilePageProtected

export const getStaticProps = async () => ({
  props: {
    pageTitle: 'My Profile',
  },
})
